export enum ChangeLogActionCode {
  OperatorCreated = 'OPERATOR_CREATED',
  OperatorEdited = 'OPERATOR_EDITED',
  OperatorStatusChanged = 'OPERATOR_STATUS_CHANGED',
  OperatorLanguagesCurrenciesUpdated = 'OPERATOR_LANGUAGES_CURRENCIES_UPDATED',

  CompanyCreated = 'COMPANY_CREATED',
  CompanyUpdated = 'COMPANY_UPDATED',
  CompanyStatusUpdated = 'COMPANY_STATUS_UPDATED',

  CompanyContactCreated = 'COMPANY_CONTACT_CREATED',
  CompanyContactUpdated = 'COMPANY_CONTACT_UPDATED',
  CompanyContactDeleted = 'COMPANY_CONTACT_DELETED',

  OperatorContactCreated = 'OPERATOR_CONTACT_CREATED',
  OperatorContactUpdated = 'OPERATOR_CONTACT_UPDATED',
  OperatorContactDeleted = 'OPERATOR_CONTACT_DELETED',

  PlatformGeneralSettingsCountriesSettingsEdited = 'PLATFORM_GENERAL_SETTINGS_COUNTRIES_SETTINGS_EDITED',
  PlatformGeneralSettingsLanguagesCurrenciesSettingsEdited = 'PLATFORM_GENERAL_SETTINGS_LANGUAGES_CURRENCIES_SETTINGS_EDITED',
  PlatformGeneralSettingsUserSettingsSettingsEdited = 'PLATFORM_GENERAL_SETTINGS_USER_SETTINGS_SETTINGS_EDITED',
  PlatformGeneralSettingsChatAndLiveFeedSettingsEdited = 'PLATFORM_GENERAL_SETTINGS_CHAT_AND_LIVE_FEED_SETTINGS_EDITED',

  PlatformPlayerAuthSecuritySettingsEdited = 'PLATFORM_PLAYER_AUTH_SECURITY_SETTINGS_EDITED',
  PlatformPlayerAuthKycSettingsEdited = 'PLATFORM_PLAYER_AUTH_KYC_SETTINGS_EDITED',
  PlatformPlayerAuthProfileSettingsEdited = 'PLATFORM_PLAYER_AUTH_PROFILE_SETTINGS_EDITED',

  PlatformThirdPartySportsAdded = 'PLATFORM_THIRD_PARTY_SPORTS_ADDED',
  PlatformThirdPartyCasinoAdded = 'PLATFORM_THIRD_PARTY_CASINO_ADDED',
  PlatformThirdPartyPaymentsAdded = 'PLATFORM_THIRD_PARTY_PAYMENTS_ADDED',
  PlatformThirdPartyLiveAdded = 'PLATFORM_THIRD_PARTY_LIVE_ADDED',
  PlatformThirdPartySupportAdded = 'PLATFORM_THIRD_PARTY_SUPPORT_ADDED',
  PlatformThirdPartySmsAdded = 'PLATFORM_THIRD_PARTY_SMS_ADDED',
  PlatformThirdPartyEmailAdded = 'PLATFORM_THIRD_PARTY_EMAIL_ADDED',
  PlatformThirdPartyToolsAdded = 'PLATFORM_THIRD_PARTY_TOOLS_ADDED',
  PlatformThirdPartyOtherAdded = 'PLATFORM_THIRD_PARTY_OTHER_ADDED',

  PlatformThirdPartySportsStatusUpdated = 'PLATFORM_THIRD_PARTY_SPORTS_STATUS_UPDATED',
  PlatformThirdPartyCasinoStatusUpdated = 'PLATFORM_THIRD_PARTY_CASINO_STATUS_UPDATED',
  PlatformThirdPartyPaymentsStatusUpdated = 'PLATFORM_THIRD_PARTY_PAYMENTS_STATUS_UPDATED',
  PlatformThirdPartyLiveStatusUpdated = 'PLATFORM_THIRD_PARTY_LIVE_STATUS_UPDATED',
  PlatformThirdPartySupportStatusUpdated = 'PLATFORM_THIRD_PARTY_SUPPORT_STATUS_UPDATED',
  PlatformThirdPartySmsStatusUpdated = 'PLATFORM_THIRD_PARTY_SMS_STATUS_UPDATED',
  PlatformThirdPartyEmailStatusUpdated = 'PLATFORM_THIRD_PARTY_EMAIL_STATUS_UPDATED',
  PlatformThirdPartyToolsStatusUpdated = 'PLATFORM_THIRD_PARTY_TOOLS_STATUS_UPDATED',
  PlatformThirdPartyOtherStatusUpdated = 'PLATFORM_THIRD_PARTY_OTHER_STATUS_UPDATED',

  PlatformThirdPartySportsEdited = 'PLATFORM_THIRD_PARTY_SPORTS_EDITED',
  PlatformThirdPartyCasinoEdited = 'PLATFORM_THIRD_PARTY_CASINO_EDITED',
  PlatformThirdPartyPaymentsEdited = 'PLATFORM_THIRD_PARTY_PAYMENTS_EDITED',
  PlatformThirdPartyLiveEdited = 'PLATFORM_THIRD_PARTY_LIVE_EDITED',
  PlatformThirdPartySupportEdited = 'PLATFORM_THIRD_PARTY_SUPPORT_EDITED',
  PlatformThirdPartySmsEdited = 'PLATFORM_THIRD_PARTY_SMS_EDITED',
  PlatformThirdPartyEmailEdited = 'PLATFORM_THIRD_PARTY_EMAIL_EDITED',
  PlatformThirdPartyToolsEdited = 'PLATFORM_THIRD_PARTY_TOOLS_EDITED',
  PlatformThirdPartyOtherEdited = 'PLATFORM_THIRD_PARTY_OTHER_EDITED',

  PlatformThirdPartySportsCredentialsRevealed = 'PLATFORM_THIRD_PARTY_SPORTS_CREDENTIALS_REVEALED',
  PlatformThirdPartyCasinoCredentialsRevealed = 'PLATFORM_THIRD_PARTY_CASINO_CREDENTIALS_REVEALED',
  PlatformThirdPartyPaymentsCredentialsRevealed = 'PLATFORM_THIRD_PARTY_PAYMENTS_CREDENTIALS_REVEALED',
  PlatformThirdPartyLiveCredentialsRevealed = 'PLATFORM_THIRD_PARTY_LIVE_CREDENTIALS_REVEALED',
  PlatformThirdPartySupportCredentialsRevealed = 'PLATFORM_THIRD_PARTY_SUPPORT_CREDENTIALS_REVEALED',
  PlatformThirdPartySmsCredentialsRevealed = 'PLATFORM_THIRD_PARTY_SMS_CREDENTIALS_REVEALED',
  PlatformThirdPartyEmailCredentialsRevealed = 'PLATFORM_THIRD_PARTY_EMAIL_CREDENTIALS_REVEALED',
  PlatformThirdPartyToolsCredentialsRevealed = 'PLATFORM_THIRD_PARTY_TOOLS_CREDENTIALS_REVEALED',
  PlatformThirdPartyOtherCredentialsRevealed = 'PLATFORM_THIRD_PARTY_OTHER_CREDENTIALS_REVEALED',

  PlatformThirdPartyKYCAdded = 'PLATFORM_THIRD_PARTY_KYC_ADDED',
  PlatformThirdPartyKYCEdited = 'PLATFORM_THIRD_PARTY_KYC_EDITED',
  PlatformThirdPartyKYCStatusUpdated = 'PLATFORM_THIRD_PARTY_KYC_STATUS_UPDATED',
  PlatformThirdPartyKYCCredentialsRevealed = 'PLATFORM_THIRD_PARTY_KYC_CREDENTIALS_REVEALED',

  UserStatusUpdated = 'USER_STATUS_UPDATED',
  UserRegistrationFinished = 'USER_REGISTRATION_FINISHED',

  OperatorLicensesUpdated = 'OPERATOR_LICENSES_UPDATED',
  OperatorLicensesCreated = 'OPERATOR_LICENSES_CREATED',
  OperatorLicensesDeleted = 'OPERATOR_LICENSES_DELETED',

  PlatformThirdPartyLiveSupportAdded = 'PLATFORM_THIRD_PARTY_LIVE_SUPPORT_ADDED',
  PlatformThirdPartyLiveSupportEdited = 'PLATFORM_THIRD_PARTY_LIVE_SUPPORT_EDITED',
  PlatformThirdPartyLiveSupportStatusUpdated = 'PLATFORM_THIRD_PARTY_LIVE_SUPPORT_STATUS_UPDATED',
  PlatformThirdPartyLiveSupportCredentialsRevealed = 'PLATFORM_THIRD_PARTY_LIVE_SUPPORT_CREDENTIALS_REVEALED',

  PlatformGeneralSettingsIpWhitelistAdded = 'PLATFORM_GENERAL_SETTINGS_IP_WHITELIST_ADDED',
  PlatformGeneralSettingsIpWhitelistDeleted = 'PLATFORM_GENERAL_SETTINGS_IP_WHITELIST_DELETED',

  PlatformSensitiveConfigRevealed = 'PLATFORM_SENSITIVE_CONFIG_REVEALED',
  PlatformRegistrationFormBuilderEdited = 'PLATFORM_REGISTRATION_FORM_BUILDER_EDITED',

  PlatformQuickToolConfigEdited = 'PLATFORM_QUICK_TOOL_CONFIG_EDITED',
  PlatformQuickToolConfigRevealed = 'PLATFORM_QUICK_TOOL_CONFIG_REVEALED',

  BroadguardHmacCredentialsUpdated = 'BROADGUARD_HMAC_CREDENTIALS_UPDATED',
  BroadguardHmacCredentialsRevealed = 'BROADGUARD_HMAC_CREDENTIALS_REVEALED',

  CrmHmacCredentialsRevealed = 'CRM_HMAC_CREDENTIALS_REVEALED',

  UserUpdated = 'USER_UPDATED',
}
